import { Box, Typography, Drawer, Autocomplete, TextField, Grid, Button } from '@mui/material';

import { useState, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { openFilterDrawer } from 'store/slices/menu';
import { setStoreFilter } from 'store/slices/dashboard';

const FilterDrawer = () => {
    const menu = useSelector((state) => state.menu);
    const dashboard = useSelector((state) => state.dashboard);
    const storeFilter = useSelector((state) => state.dashboard.filters.store);

    const [localStoreFilter, setLocalStoreFilter] = useState(storeFilter);

    useEffect(() => {
        setLocalStoreFilter(storeFilter);
    }, [menu.filter.opened]);

    const dispatch = useDispatch();

    const toggleDrawer = () => {
        dispatch(openFilterDrawer());
    };

    const applyFilter = () => {
        dispatch(setStoreFilter(localStoreFilter));
        dispatch(openFilterDrawer());
    };

    const cleanFilter = () => {
        setLocalStoreFilter([]);
        dispatch(setStoreFilter([]));
    };

    const handleChangeAutoComplete = (e, value) => {
        setLocalStoreFilter(value);
    };

    const list = () => (
        <Box sx={{ width: 280 }} role="presentation">
            <Grid container spacing={1} p={1}>
                <Grid item xs={12}>
                    <Typography variant="h5" component="span">
                        Filtrar por:
                    </Typography>
                </Grid>
                <Grid item xs={12} mt={1}>
                    <Autocomplete
                        fullWidth
                        multiple
                        limitTags={2}
                        id="multiple-limit-tags"
                        options={dashboard.stores.active_only ?? []}
                        getOptionLabel={(option) => option.name}
                        value={localStoreFilter || []}
                        onChange={handleChangeAutoComplete}
                        renderInput={(params) => <TextField {...params} label="Filtro por Loja" />}
                        size="small"
                    />
                </Grid>
                <Grid item xs={6}>
                    <Button fullWidth variant="outlined" color="secondary" onClick={cleanFilter}>
                        Limpar
                    </Button>
                </Grid>
                <Grid item xs={6}>
                    <Button fullWidth variant="outlined" color="secondary" onClick={applyFilter}>
                        Aplicar
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );

    return (
        <>
            <Drawer sx={{ zIndex: 1300 }} anchor="right" open={menu.filter.enabled && menu.filter.opened} onClose={toggleDrawer}>
                {list()}
            </Drawer>
        </>
    );
};

export default FilterDrawer;
